import AuctionHouseAuctionTile from "./AuctionHouseAuctionTile";

export default AuctionHouseAuctionTile;
